import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useCategories } from '../context/CategoriesContext';
import { useSettings } from '../context/SettingsContext';

const Footer = () => {
  const { categories } = useCategories();
  const { settings } = useSettings();
  return (
    <footer className="bg-[#0F172A] text-neutral-300 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-10 pb-10 border-b border-neutral-800">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src={settings?.footer_logo_image || settings?.logo_image || ""}
                alt="Mohammed Riaz & Partner LLC"
                className="h-12 w-auto rounded-md object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-display text-lg font-bold text-white">
                  Mohammed Riaz
                </span>
                <span className="text-[10px] font-semibold text-[#71B7F0] tracking-[0.2em] uppercase">
                  &amp; Partner LLC
                </span>
              </div>
            </Link>
            <p className="text-neutral-400 max-w-md text-sm">
              {settings?.footer_description ||
                'B2B distribution of FMCG essentials across Oman — snacks, sweets, beverages and bottled water. From our family to yours.'}
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Twitter, Facebook, Instagram].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-neutral-900 hover:bg-[#0078D4] flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h5 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">Products</h5>
            <ul className="space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-neutral-400 hover:text-white transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 className="text-white font-semibold mb-4 text-sm tracking-wide uppercase">Contact</h5>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#71B7F0]" />
                <span>{settings?.footer_address || 'Muscat, Sultanate of Oman'}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#71B7F0]" />
                <span>{settings?.footer_phone || '+968 9000 0000'}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#71B7F0]" />
                <span>{settings?.footer_email || 'info@mohammedriaz.om'}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-sm text-neutral-500">
          <span>{settings?.footer_copyright || '© 2025 Mohammed Riaz & Partner LLC. All rights reserved.'}</span>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
